import { render, staticRenderFns } from "./PositionList.vue?vue&type=template&id=7d2f1df6"
import script from "../../controllers/position/position-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/position/position-list.js?vue&type=script&lang=js&external"
import style0 from "./PositionList.vue?vue&type=style&index=0&id=7d2f1df6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports